import React, { Component } from "react";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/swiper.min.css";
import "swiper/components/pagination/pagination.min.css";
import "swiper/components/navigation/navigation.min.css";
import { ChevronRight, ChevronLeft } from "react-feather";
// import Swiper core and required modules
import { Link } from "react-router-dom";
import SwiperCore, { Pagination, Navigation } from "swiper/core";
import bookmark from "../img/bookmark.svg";
import TrendingJobs3 from "../img/trending3.png";
import TrendingJobs2 from "../img/trending2.png";
import TrendingJobs4 from "../img/trending4.png";
import TrendingJobs1 from "../img/trending1.png";
import { connect } from "react-redux";
import { getSingleJobAction, getRelatedJobs } from "store/SingleJob";
import { getRelatedPortfoliosByIDAction } from "store/Home";
// install Swiper modules
import pin from "../img/pin.svg";
SwiperCore.use([Pagination, Navigation]);

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      Jobs: [],
    };
  }
  addDefaultSrc(ev) {
    ev.target.src = TrendingJobs2;
  }
  componentDidUpdate = async (prevProps) => {
    // console.log(prevProps)
    if (this.props.id !== prevProps.id) {
      let previewJobs = this.props.previewjob;
      if (previewJobs) {
        let relatedJobs = await this.props.getRelatedJobs({
          JobIds: previewJobs.p_featuredJob,
        });
        if (relatedJobs) {
          // console.log(relatedJobs.data.Data);
          this.setState({ Jobs: relatedJobs.data.Data });
        } else {
          this.setState({ Jobs: [] });
        }
      }
    }
  };
  async componentDidMount() {
    let previewJobs = this.props.previewjob;
    if (previewJobs) {
      let relatedJobs = await this.props.getRelatedJobs({
        JobIds: previewJobs.p_featuredJob,
      });
      if (relatedJobs) {
        // console.log(relatedJobs.data.Data);
        this.setState({ Jobs: relatedJobs.Data });
      } else {
        this.setState({ Jobs: [] });
      }
    }
  }
  componentWillUnmount(){
    this.setState({Jobs:[]})
  }
  render() {
    return (
      <>
        <div className='flex justify-between items-center mt-16 mb-8'>
          <h2 className='fsize28 sm-fsize16 font-bold uppercase'>
            Explore career opportunities
          </h2>
          <div className='flex '>
            <ChevronLeft
              width='30px'
              height='30px'
              className='trend-left-i mr-2 disabled'
            />
            <ChevronRight
              width='30px'
              height='30px'
              className='trend-right-i'
            />
          </div>
        </div>
        <Swiper
          breakpoints={{
            1366: {
              slidesPerView: 4,
              spaceBetween: 30,
            },
            1024: {
              slidesPerView: 4,
              spaceBetween: 30,
            },
            991: {
              slidesPerView: 3,
              spaceBetween: 30,
            },
            420: {
              slidesPerView: 2,
              spaceBetween: 15,
            },
            375: {
              slidesPerView: 2,
              spaceBetween: 15,
            },
            320: {
              slidesPerView: 1,
              spaceBetween: 15,
            },
          }}
          spaceBetween={30}
          slidesPerGroup={4}
          loop={true}
          loopFillGroupWithBlank={true}
          pagination={{
            clickable: true,
          }}
          navigation={false}
          className='mySwiper swiperpagination-dot'
        >
          {/* ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// */}
          {this.state.Jobs.map((job, index) => (
            <SwiperSlide className='shadow-lg rounded-12px mb-4 showcard'>
              <div className='img__wrap w-full'>
                <div>
                  <div className='relative'>
                    <img
                      onError={this.addDefaultSrc}
                      src={
                        process.env.REACT_APP_IMAGE_BASE_MG + "/" + job.f_path
                      }
                      className='w-full rounded-t-12px object-fill cust-h210px'
                      alt='banner-img '
                    />
                    <div className='absolute bookmark-parent text-white rounded-full'>
                      <img src={bookmark} className='bookmark-t-c' />
                    </div>
                  </div>
                  <div className='lg:p-4 md:p-4 lg:p-4  md:p-4 p-3'>
                    <p className='text-black  sm-fsize12 sm-font-semibold line-clamp-1	font-medium fsize18   '>
                      {job.f_title || "The Title"}
                    </p>
                  </div>
                </div>
                <div className='img__description_layer'>
                  <h1 className='img__description trend-hover-h truncate'>
                    {job.f_category || "Banking"}
                  </h1>

                  <div className='lg:p-4  md:p-4 p-2'>
                    <p className='text-black font-bold  sm-fsize12 line-clamp-1 fsize18'>
                      {job.f_title || "The Title"}
                    </p>
                  </div>
                  <p className='text-muted-1 '>
                    Required Experience:{" "}
                    <span className='text-black '>{job.Experience || "0"}</span>
                  </p>
                  <p className='text-muted-1 '>
                    Education:{" "}
                    <span className='text-black '>
                      {job.Education || "ANY"}
                    </span>
                  </p>
                  <div className='flex justify-around mt-4'>
                    <div className='flex items-center'>
                      <img src={pin} className='pn-icon-w' />

                      <p className='text-muted-1 ml-2'>
                        {job.Location || "UNKNOWN"}
                      </p>
                    </div>

                    <p className='text-muted-1 '>
                      {`${job.f_createdDate}`.split("T")[0]} ago
                    </p>
                  </div>

                  <div className='flex justify-center'>
                    <Link
                      to={`/CareerApplicant/career/job-details/${job.f_jobId}`}
                    >
                      <button className='cust-trendapply-btn flex'>
                        APPLY NOW
                      </button>
                    </Link>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
          {/* ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// */}
        </Swiper>
      </>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    previewjob: state.SinglePortfolio.home.PREVIEWJOB.Data?state.SinglePortfolio.home.PREVIEWJOB.Data[0]:"",
    RelatedPortfolios: state.Home.home.GET_RELATED_PORTFOLIOS,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getRelatedJobs: async (payload) => await dispatch(getRelatedJobs(payload)),
    getRelatedPortfolios: async (payload) =>
      await dispatch(getRelatedPortfoliosByIDAction(payload)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(App);
